import {
  AdvancedTransformControlBarItem,
  BasicTransformControlBarTabs,
  Configuration,
  ExportFormat,
  ImageFormat,
  Tool
} from 'photoeditorsdk'

export const EDITOR_CONFIG: Configuration = {
  container: '#editor',
  displayCloseWarning: true,
  layout: 'basic',
  theme: 'dark',
  assetBaseUrl: '/assets/',
  image: '',
  tools: [Tool.TRANSFORM, Tool.ADJUSTMENT],
  defaultTool: Tool.TRANSFORM,
  export: {
    image: {
      quality: 1,
      exportType: ExportFormat.DATA_URL,
      format: ImageFormat.JPEG,
      enableDownload: false
    }
  },
  transform: {
    basicUIToolControlBarTabsOrder: [BasicTransformControlBarTabs.FlipRotate, BasicTransformControlBarTabs.CropSize],
    advancedUIToolControlBarOrder: [
      AdvancedTransformControlBarItem.ResetTransformButton,
      AdvancedTransformControlBarItem.CropSizeInput
    ],
    categories: [
      {
        identifier: 'imgly_transforms_common',
        items: [
          { identifier: 'imgly_transform_common_custom' },
          { identifier: 'imgly_transform_common_square' },
          { identifier: 'imgly_transform_common_4' },
          { identifier: 'imgly_transform_common_16' },
          { identifier: 'imgly_transform_common_3' },
          { identifier: 'imgly_transform_common_9' }
        ]
      }
    ],

    flattenCategories: true
  },
  custom: {
    languages: {
      en: {
        mainCanvasActions: {
          buttonExport: 'Save Image'
        },
        transform: {
          controls: {
            buttonReset: 'Reset'
          }
        }
      }
    }
  },
  license:
    '{"api_token":"3_iJtJB1qxWaFvOSqYR67w","app_identifiers":["localhost","app.uprightlabs.com","www.app.uprightlabs.com","app-staging.uprightlabs.com","www.app-staging.uprightlabs.com"],"available_actions":[],"domains":["https://api.photoeditorsdk.com"],"enterprise_license":false,"expires_at":null,"features":["camera","library","export","customassets","whitelabel","adjustment","transform"],"issued_at":1632868727,"minimum_sdk_version":"1.0","owner":"Upright Labs","platform":"HTML5","products":["pesdk"],"version":"2.4","signature":"ilyYjDl4vzDeXljYjZUpEx20b3Yxa2mVWuApX207LvIl9NT6myb0Cx2HFkaceKV9wAoTX0FgvjaFtfkH6n/beTZYP82XtHr/MH/8s7y6/BGN1B64L4CVcG7DQpDDHfFVLB8LwAviRGZ74iJJ/3b8lUXOhUO/DWFtwJGi3a8mC/CBVVLj38rJ336dj9IzK+2FwxKilUEM38hbTeknImk6fR5a2/iazNlUA/T2NqxupXCd+cTw0jTCKsM7EVdVvL1CPouLEpq6i4/R+2YUFfMYziOoo9ia+XO7aya+nXPMwRwbDxGz2rk15kX9xw76B4wFNxgaMTxYDPh8IHTu9a7p7+JBWS9npcrQfHFiNT93/jBX5ultI91IfoNnWDyUcxMPqS9ORKh0ZtCIkZyr6t1yge0xbDWE0pZoGmnoZ8AS/Vr5ZDErK2bE6C0ENLIdoXwaTY11U7cmxWttYQ5ka7VFJIas6KJjMFUVe9bdh8BTB7p4Y7BxI7IG/4QPBE9XuuTLSrtmSE14whJc/PzFjIbxktpAHw8ksJNi6xbITTIhWbfJzkvDSAuj0v2JSopjcRr55vlEMebd8DzQc0Tw9QEWpvRQVqEQa6+JI2fx7iB4HatUL168SFQTM9Wl8pe4nNSBy/pAM2wkiXPAC+ZOw82MwfkozGe/IWLRDtTgaRskRDo="}'
}
